
import {
  buildOfferDisplay,
  familyConditions,
  formatRate,
  subsidyMatrixCells,
  yearsLabel,
} from '~/helpers/offerParts';

export default {
  name: 'BankCardInfo',

  props: {
    bank: {
      type: Object,
      default: () => ({}),
    },
    currentBank: {
      type: Object,
      default: () => null,
    },
    filteredValues: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      selectedMatrixInterest: null,
      selectedMatrixDuration: null,
      isPatchLoading: false,
    }
  },

  computed: {
    isPartsOpen() {
      if (!this.bank || !this.currentBank) {
        return false;
      }
      if (this.bank.sdelkaHash && this.currentBank.sdelkaHash) {
        return this.currentBank.sdelkaHash === this.bank.sdelkaHash;
      }
      return this.currentBank.id === this.bank.id;
    },
    isCmsLogo() {
      return typeof this.bank?.bank?.image_id === 'number' && Number(this.bank.bank.image_id) > 0;
    },
    bankLogoUrl() {
      if (typeof this.bank?.bank?.image_id === 'string' && this.bank.bank.image_id) {
        return this.bank.bank.image_id;
      }
      return this.bank?.bank?.logoUrl || '';
    },
    offerDisplay() {
      if (!this.bank) {
        return {
          isCompound: false,
          summaryRate: null,
          summaryFromPrefix: true,
          summaryPayment: 0,
          rows: [],
          conditions: [],
        };
      }
      return buildOfferDisplay(this.bank);
    },
    offerFamilyDetails() {
      return this.bank ? familyConditions(this.bank) : [];
    },
    matrixCells() {
      return this.bank ? subsidyMatrixCells(this.bank) : [];
    },
    matrixInterestOptions() {
      return Array.from(new Set(
        this.matrixCells.map((cell) => cell.interest).filter((value) => value != null)
      ));
    },
    matrixDurationOptions() {
      return Array.from(new Set(
        this.matrixCells.map((cell) => cell.duration).filter((value) => value != null)
      ));
    },
    hasDetails() {
      return this.offerDisplay.isCompound
        || this.offerFamilyDetails.length > 0
        || Boolean((this.bank?.message || '').trim());
    },
    monthlyPayment() {
      if (this.offerDisplay.summaryPayment > 0) {
        return this.offerDisplay.summaryPayment;
      }
      return this.$kalculateMonthlyPayment({
        cost: this.filteredValues.cost,
        firstPay: this.filteredValues.firstPay,
        interestRate: this.bank?.interestRate,
        term: this.filteredValues.term,
      });
    },
    setMessage() {
      return (this.bank?.message || '').trim();
    },
  },

  watch: {
    'bank.sdelkaHash': function () {
      this.syncMatrixSelection();
    },
    'bank.id': function () {
      this.syncMatrixSelection();
    },
  },

  methods: {
    syncMatrixSelection() {
      const first = this.matrixCells[0];
      this.selectedMatrixInterest = first?.interest ?? null;
      this.selectedMatrixDuration = first?.duration ?? null;
    },
    findMatrixCell(interest, duration) {
      return this.matrixCells.find((cell) => (
        (interest == null || cell.interest === interest)
        && (duration == null || cell.duration === duration)
      )) || this.matrixCells.find((cell) => cell.interest === interest)
        || this.matrixCells.find((cell) => cell.duration === duration);
    },
    async patchOffer(cell) {
      if (!this.bank?.sdelkaHash || cell.interest == null || cell.duration == null) {
        return;
      }
      const { cost, firstPay, term } = this.filteredValues;
      if (!cost || firstPay == null || term == null) {
        return;
      }
      this.isPatchLoading = true;
      try {
        const res = await this.$api.agent.transport.post('/banks/patched-offer', {
          hash: this.bank.sdelkaHash,
          interest: cell.interest,
          periodDuration: cell.duration,
          cost,
          firstPay,
          term,
        });
        if (res.data) {
          this.$emit('updateBank', res.data);
        }
      } catch (err) {
        console.log('patched-offer error:', err);
      } finally {
        this.isPatchLoading = false;
      }
    },
    onMatrixInterestChange(raw) {
      const interest = Number(raw);
      this.selectedMatrixInterest = interest;
      const cell = this.findMatrixCell(interest, this.selectedMatrixDuration);
      if (cell?.duration != null) {
        this.selectedMatrixDuration = cell.duration;
      }
      if (cell) {
        this.patchOffer(cell);
      }
    },
    onMatrixDurationChange(raw) {
      const duration = Number(raw);
      this.selectedMatrixDuration = duration;
      const cell = this.findMatrixCell(this.selectedMatrixInterest, duration);
      if (cell?.interest != null) {
        this.selectedMatrixInterest = cell.interest;
      }
      if (cell) {
        this.patchOffer(cell);
      }
    },
    openOffer(item) {
      if (this.isPartsOpen) {
        this.$emit('setCurrentBank', null);
        return;
      }
      this.$emit('setCurrentBank', item);
    },
    formatRate,
    yearsLabel,
  },

  mounted() {
    this.syncMatrixSelection();
  },
}
